export default {
  control: {
    backgroundColor: 'transparent',
    fontSize: '1rem',
    fontWeight: 'normal',
  },

  '&multiLine': {
    control: {
      minHeight: 75,
    },
    highlighter: {
      padding: 9,
      border: 0,
    },
    input: {
      backgroundColor: 'transparent',
      cursor: 'text',
      padding: 9,
      border: 'none',
      outline: 'none',
    },
  },

  '&singleLine': {
    display: 'inline-block',
    width: 180,

    highlighter: {
      padding: 1,
      border: '2px inset transparent',
    },
    input: {
      padding: 1,
      border: 'none',
    },
  },

  suggestions: {
    overflow: 'auto',
    maxHeight: '100px',
    marginBottom: '20px',

    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
}
